      <!-- BEGIN: Footer For Desktop and tab -->
      <footer class="md:block hidden" id="footer">
        <div class="site-footer px-6 bg-white dark:bg-slate-800 text-slate-500 dark:text-slate-300 py-4 ltr:ml-[248px] rtl:mr-[248px]"
        [class.margin-0]="dashcodeHelper.Settings.isSmallScreen">
          <div class="grid md:grid-cols-2 grid-cols-1 md:gap-5">
            <div class="text-center ltr:md:text-start rtl:md:text-right text-sm">
              COPYRIGHT ©
              <span id="thisYear">{{thisYear}}</span>
              Plateforme D'Clic Jeune du CLLAJ Martinique, All rights Reserved
            </div>
            <div class="ltr:md:text-right rtl:md:text-end text-center text-sm">
              Made by
              <a href="https://bambootech.fr" target="_blank" class="text-primary-500 font-semibold">
                Xolo Go OÜ - RLB
              </a>
            </div>
          </div>
        </div>
      </footer>

      <!-- END: Footer For Desktop and tab -->
